import type { FC } from 'react';

import { AppConfigPage } from '../../features/app-config/app-config';
import { useIsAppConfiguratorQuery } from '../../features/app-config/hooks/use-query/use-is-app-configurator-query';
import { IdmConfigPage } from '../../features/config/idm-config-page';
import { useAppConfigContext } from '../../providers/is-idm-provider/app-config-provider';

export const AppConfigView: FC = () => {
  const { data: hasAppConfigPermission } = useIsAppConfiguratorQuery();
  const { isIdm } = useAppConfigContext();

  if (isIdm) {
    return <IdmConfigPage />;
  }

  return <AppConfigPage hasAppConfigPermission={hasAppConfigPermission} />;
};
